/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode, Ref } from 'react';

import './BrowserFrame.css';
import { LogoLock } from '../../../assets';

type BrowserFrameProps = {
	children: ReactNode;
	style: object;
	frameViewHeight?: number;
	setBrowserFrameRef?: Ref<HTMLDivElement>;
};

export function BrowserFrame( { children, style, setBrowserFrameRef, frameViewHeight }: BrowserFrameProps ): ReactNode {
	return (
		<div style={ style }>
			<div className={ 'browser-frame browser-frame_with-url' } ref={ setBrowserFrameRef }>
				<div className={ 'browser-frame__bar' }>
					<div className={ 'browser-frame__buttons' }>
						<span className={ 'browser-frame__button browser-frame__button_grey' }></span>
						<span className={ 'browser-frame__button browser-frame__button_grey' }></span>
						<span className={ 'browser-frame__button browser-frame__button_grey' }></span>
					</div>
					<div className={ 'browser-frame__address' }>
						<img src={ LogoLock } /> ckeditor.com
					</div>
					<div className={ 'browser-frame__right-buttons' }>
					</div>
				</div>
				<div className={ 'browser-frame__view' } style={ { height: frameViewHeight + 'px' } }>
					{ children }
				</div>
			</div>
			<div className={ 'browser-frame__info-text' }>
				This is a preview of your editor. You can modify the editor’s appearance later in the setup process.
			</div>
		</div>
	);
}
